import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerUpRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowCornerUpRight"><Path fillRule="evenodd" clipRule="evenodd" d="M5 20.4142V10.4142H17.5858L14.5858 13.4142L16 14.8284L21.4142 9.41421L16 4L14.5858 5.41421L17.5858 8.41421H3V20.4142H5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowCornerUpRight;
